export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      currentTab: 1,
    }
  },

  mounted() {
    this.currentTab = this.items[0]
  },

  methods: {
    changeTab(index) {
      this.currentTab = this.items[index]
    },

    isActive(index) {
      return this.currentTab === this.items[index]
    },

    getHeartItemClass(index) {
      const heartClasses = {
        0: 'first--type',
        1: 'second--type',
        2: 'third--type',
      }

      const heartIndex = 0
      const rocketIndex = 1
      const isRocketChecked =
        index === heartIndex && this.currentTab === this.items[rocketIndex]
      const heartClassWithRocket = isRocketChecked
        ? 'love-tabs__heart-container__item--heart-rocket'
        : ''

      return `${heartClasses[index]} ${heartClassWithRocket}`
    },
  },
}
